import React, { Component } from 'react';
import '../../../src/styles/Journals.css';
import { FaChevronUp } from 'react-icons/fa';
import { Accordion } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Card } from 'react-bootstrap';
import { FaChevronDown } from 'react-icons/fa';
import { Collapse } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import queryString from 'query-string';
import { Button } from 'react-bootstrap';
import ChapterModal from 'react-bootstrap/Modal'
import { appService } from '../../_services';
import { authHeader, config } from '../../_helpers';
import DocumentMeta from 'react-document-meta';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { Redirect, Route } from 'react-router-dom';
import EmailModal from 'react-bootstrap/Modal';
import ReactGA from 'react-ga';

var fileName = "";
var AbstractTitle = '', productId = '', issueId = '', VolumeId = '', volumeData = '', articledata = '', getIssue = '', getAuthors = '', content = '', parameters = '', authorFullName = '', Emailparameters = "";
let params = '', url = '', path = '', options = '', PubDate = '', useragent = navigator.userAgent;
let count = 0;
var Hidebutton = false
var Displaystyle = {
    display: 'inline-block'
}
var accordion = {
    backgroundColor: '#F6F6F6',
    padding: '10px 0px',
    borderLeft: '1px solid #CCCCCC',
    borderRight: '1px solid #CCCCCC',
    borderTop: '1px solid #CCCCCC',
    zindex: '9999'
}
var AccordionTitle = {
    color: '#474747',
    fontSize: '18px',
    paddingLeft: '2%'
}
export class JournalIssue extends Component {
    //displayName = JournalIssue.name
    constructor(props) {
        super(props);
        this.state = { //this is a temporary fix for hiding/showing links if not logged in -  condition will be modified 
            login: false, Subscribed: false,
            show: false,
            journalTopic: "",
            volumeNo: "",
            issueNo: "",
            issueText: '',
            showAbstractText: false,
            showPdfUrl: true,
            OnlinePrice: '',
            redirectToSearch: false,
            printedmaterial: '', PdfPrice: '',
            email: 'dawn.danish@wolterskluwer.com', lastElementid: '', journalTitle: '', JournalId:0, NextIssueNo: '', NextIssueId: '', PrevIssueNo: '', PrevIssueId: '', PrevIssueText: '', NextIssueText: '', NextIssueTextNo: '', PrevIssueTextNo: '',
            user: '', TopicId: '', TopicName: '', newcurrency: '', Publishedyear: '', PublicationMon: '', Reviewedyear: '', ReviewedMon: '', issueTextNo: ''
        }
        this.state = {
            checked: false,
            checked1: true,
            journalIssues: [],
            journalImage: [],
            mainEditors: [],
            editors: [],
            editorialComment: [],
            volumes: [],
            articlesList: [],
            uniqueTitle: [],
            productprice: [],
            link: '',
            code: '',
            samplePDF: [],
            emailReciepient: '', emailRec: '', emailName: '', FirstRange: '', LastRange: '',
            redirectToLogin: false,
            searchAuthor: "",
            ShowSublist: [], articleType: [], isArticleTypeDevided: false
        }
        //this.handleShow = this.handleShow.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onChange1 = this.onChange1.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
        this.handleChapterModalShow = this.handleChapterModalShow.bind(this);
        this.handleChapterModalClose = this.handleChapterModalClose.bind(this);
        this.sendEmail = this.sendEmail.bind(this);
        this.handleValidation = this.handleValidation.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.searchAuthorContent = this.searchAuthorContent.bind(this);
        this.handleEmailModalShow = this.handleEmailModalShow.bind(this);
        this.handleEmailModalClose = this.handleEmailModalClose.bind(this);
        this.sendShareByEmail = this.sendShareByEmail.bind(this)
        this.handleEmailValidation = this.handleEmailValidation.bind(this)
        this.logoutsession = this.logoutsession.bind(this);
        this.handleEtocModalShow = this.handleEtocModalShow.bind(this);
        this.handleEtocModalClose = this.handleEtocModalClose.bind(this);
        this.HandleClick = this.HandleClick.bind(this);
    }

    HandleClick(e) {
        //console.log(e.target);
        if (this.state.ShowSublist.some(item => e.target.id === item)
            //&& newel[0].className == "fa fa-chevron-down"
        ) {

            let index = this.state.ShowSublist.indexOf(e.target.id);
            if (index > -1) {
                this.state.ShowSublist.splice(index, 1);
                this.setState({ ShowSublist: this.state.ShowSublist });
            };

        }
        else {
            let options = this.state.ShowSublist;
            options.push(e.target.id);

            this.setState({
                ShowSublist: options
            })

        }

    }

    handleEtocModalClose() {
        this.setState({ handleEtocModalShow: false });
    }

    handleEtocModalShow() {
        this.setState({ handleEtocModalShow: true });
    }
    logoutsession() {

        var self = this;
        if (localStorage.getItem('user') !== null) {
            appService.getAll('/User/logOutDecreseActiveCount').then(function (response) {
                appService.getAll('/User/logOut').then(function (response) {

                    //localStorage.removeItem('user');
                    //localStorage.removeItem('userId');
                    //localStorage.removeItem('usersubscription');
                    //localStorage.removeItem('company');
                    //localStorage.removeItem('firstName');
                    //localStorage.removeItem('lastName');
                    //localStorage.removeItem('salesForceID');
                    localStorage.clear();
                    localStorage.setItem('logoutclick', 'true');

                });
                window['LastURL'] = '';
            });

        }
        self.setState({
            redirectToLogin: true
        })
    }
    handleEmailValidation() {
        var self = this;
        let fields = self.state.fields;
        let errors = {};
        let formIsValid = true;

        var emailTo = this.refs["email"].value;

        if (emailTo == "") {
            formIsValid = false;
            this.state.emailRec = "* Required field";
        }

        if (emailTo != "") {
            var emails = emailTo.split(";");
            emails.forEach(function (emails) {
                let lastAtPos = emails.lastIndexOf('@');
                let lastDotPos = emails.lastIndexOf('.');

                if (!(lastAtPos < lastDotPos && lastAtPos > 0 && emails.indexOf('@@') == -1 && lastDotPos > 2 && (emails.length - lastDotPos) > 2)) {
                    formIsValid = false;
                    self.state.emailRec = "* Please enter a valid email address";
                }
            })
        }
        self.setState({ errors: errors });

        return formIsValid;

    }

    sendShareByEmail() {
        if (this.handleEmailValidation()) {
            this.state.emailRec = '';
            Emailparameters = {
                Email: this.refs["email"].value,
                Subject: this.refs["SubjectTitle"].value == "" ? this.state.journalTitle : this.refs["SubjectTitle"].value,
                Category: window.location.href,
                AdditionalInfo: this.refs["AddInfo"].value
            }
            var self = this;
            appService.submit('/Email/ShareByEmail', Emailparameters)
                .then(function (data) {
                    if (data == "Success") {
                        self.setState({ handleEmailModalShow: false });
                    }
                });
        }
    }

    decodeHtml(html) {
        var txt = document.createElement("textarea");
        txt.innerHTML = html;
        return txt.value;
    }

    searchAuthorContent = (e) => {
        this.state.searchAuthor = e;
        //window['SearchAuthor'] = e;
        this.setState({ redirectToSearch: true });
    }

    handleSelect() {
        window.scrollTo(0, 0);
        //console.log(window['NTPT_PGEXTRA']);

    }
    handleClose() {
        this.setState({ show: false, emailName: '', emailReciepient: '' });
    }
    handleShow(e) {
        fileName = "Journals\\" + this.state.code + "\\" + e;
        this.setState({ show: true });
    }
    onChange(e) {
        this.setState({ 'checked': e.target.checked });
    }

    onChange1(e) {
        this.setState({ 'checked1': e.target.checked });
    }
    handleChapterModalClose() {
        this.setState({ handleChapterModalShow: false });
    }

    handleEmailModalClose() {
        this.setState({ handleEmailModalShow: false });
    }

    handleEmailModalShow() {
        this.setState({ handleEmailModalShow: true });
    }

    sendEmail() {
        localStorage.setItem('link', JSON.stringify(window.location.href));
        window.scrollTo(0, 0);
    }
    async handleChapterModalShow() {
        if (this.state.checked == false && this.state.checked1 == false) {
            alert('Please choose your subscription ');
        }
        else {

            const requestOptionsCountry = {

                headers: authHeader(),

            };

            const response = await fetch("https://ipapi.co/json/", requestOptionsCountry);
            const json = await response.json();
            this.setState({ currency: json.currency });

            const requestOptions = {
                method: 'POST',
                headers: authHeader(),
                body: {},
            };
            //url = this.props.location.search;
            //params = queryString.parse(url);

            let ProductId = document.location.pathname.split("/")[4];

            var self = this;
            fetch(config.apiUrl + '/Cart/AddToCart?IsProductId=true&ProductId=' + ProductId + '&OnlineThreeMonthsDelivery=' + this.state.checked + '&PrintDelivery=' + this.state.checked1 + '&currency=' + this.state.currency, requestOptions)
                .then(function (data) {
                    self.setState({ handleChapterModalShow: true });
                });
        }
    }

    componentDidMount() {
        //alert(this.props.match.params.id);
        if (localStorage.getItem('user') !== null) {
            this.state.login = true;
        }
        else {
            this.state.login = false;
        }

        url = this.props.location.search;

        if (this.props.match.params.id) {
            issueId = this.props.match.params.id
        }
        else {
            params = queryString.parse(url);
            if (params.id) {
                // productId = params.Productid
                issueId = params.Issueid
                // volumeId = params.Volumeid
            }
        }
        //params = queryString.parse(url);
        this.state.user = JSON.parse(localStorage.getItem('user'));
        parameters = { IssueId: issueId, user: this.state.user };

        var self = this;
        self.setState({ volid: params.Volumeid });
        appService.getByIssueId('Product/GetJournalIssue', parameters)

            .then(function (data) {
                if (data == "Error found") {
                    //window.location = "/Maintenance";;
                }

                //  console.log(data);
                self.setState({ samplePDF: data.samplePDF });
                self.setState({ journalIssues: data });
                self.setState({ journalImage: data.imageUrl })
                //self.setState({ mainEditors: data.mainEditors })
                //self.setState({ editors: data.editors })
                self.setState({ editorialComment: data.editorialComment })
                self.setState({ Subscribed: data.subscribed })
                self.setState({ journalTopic: data.topic })
                self.setState({ journalTitle: data.title });
                self.setState({JournalId:data.id})
                volumeData = data.volumes;
                self.setState({ volumeNo: volumeData[0].volumeNo });
                getIssue = volumeData[0].issues;
                self.setState({ issueNo: getIssue[0].issueNo });
                self.setState({ issueText: getIssue[0].issueText });
                self.setState({ issueTextNo: getIssue[0].issueTextNo });
                //self.setState({ articlesList: getIssue[0].articleType[0].articles });
                self.setState({ articlesList: [].concat.apply([], getIssue[0].articleType.map(a => a.articles)) });
                articledata = getIssue[0].articleType[0].articles;
                self.setState({ FirstRange: articledata[0].firstPage });
                self.setState({ LastRange: articledata[articledata.length - 1].lastPage });
                self.setState({ productprice: data.productPrice });
                self.setState({ showPdfUrl: true });
                self.setState({ TopicId: data.topicId });
                self.setState({ code: data.code });
                self.setState({ TopicName: data.topic });
                self.setState({ Publishedyear: data.publicationDate });
                self.setState({ PublicationMon: data.publicationMon });
                self.setState({ isArticleTypeDevided: data.isArticleTypeDevided });
                self.setState({ articleType: getIssue[0].articleType });
                fetch("https://ipapi.co/json/")
                    .then(res => res.json())
                    .then(
                    (result) => {
                        //console.log(result)
                        self.setState({ newcurrency: result.currency });
                        });

                let lastid = self.state.ShowSublist;
                getIssue[0].articleType.map((items, index) => {
                    lastid.push(index + "_" + index);
                    self.setState({
                        ShowSublist: lastid
                    })
                })

                if (self.state.productprice != null) {
                    self.state.productprice.map((item) => {
                        //console.log(self.state.newcurrency);
                        //console.log(item);
                        if (self.state.newcurrency == "EURO" || self.state.newcurrency == "INR" || self.state.newcurrency == '') {

                            if (item.type == "2") {
                                self.setState({ OnlinePrice: item.euro });
                            }
                            if (item.type == "3") {
                                self.setState({ printedmaterial: item.euro });
                            }
                            if (item.type == "1") {
                                self.setState({ PdfPrice: item.euro });
                            }
                        }
                        else if (self.state.newcurrency == "POUND") {

                            if (item.type == "2") {
                                self.setState({ OnlinePrice: item.pound });
                            }
                            if (item.type == "3") {
                                self.setState({ printedmaterial: item.pound });
                            }
                            if (item.type == "1") {
                                self.setState({ PdfPrice: item.pound });
                            }
                        }
                        else {

                            if (item.type == "2") {
                                self.setState({ OnlinePrice: item.usd });
                            }
                            if (item.type == "3") {
                                self.setState({ printedmaterial: item.usd });
                            }
                            if (item.type == "1") {
                                self.setState({ PdfPrice: item.usd });
                            }
                        }
                    })
                }

                if (volumeData[0].nextIssue.length > 0) {
                    self.setState({ NextIssueNo: volumeData[0].nextIssue[0].issueNo });
                    self.setState({ NextIssueId: volumeData[0].nextIssue[0].id });
                    self.setState({ NextIssueText: volumeData[0].nextIssue[0].issueText });
                    self.setState({ NextIssueTextNo: volumeData[0].nextIssue[0].issueTextNo })
                }
                if (volumeData[0].prevIssue.length > 0) {
                    self.setState({ PrevIssueNo: volumeData[0].prevIssue[0].issueNo });
                    self.setState({ PrevIssueId: volumeData[0].prevIssue[0].id });
                    self.setState({ PrevIssueText: volumeData[0].prevIssue[0].issueText });
                    self.setState({ PrevIssueTextNo: volumeData[0].prevIssue[0].issueTextNo })
                }


                if (localStorage.getItem('user') !== null) {
                    window['NTPT_PGEXTRA'] = 'event_type=journal_abstract&ProductId=' + self.state.journalIssues.id + '&ProductTitle=' + self.state.journalTitle + '&volume=' + self.props.match.params.volume + '&issue=' + self.props.match.params.issue + '&user_id=' + localStorage.getItem('salesForceID') + '&User=' + localStorage.getItem('user') + '&Subscribed=' + data.subscribed + '&platform=klo&useragent=' + useragent;
                    const script = document.createElement("script");
                    script.src = "/siqpagetag.js";
                    script.async = true;
                    document.body.appendChild(script);
                }
                else {
                    window['NTPT_PGEXTRA'] = 'event_type=journal_abstract&ProductId=' + self.state.journalIssues.id + '&ProductTitle=' + self.state.journalTitle + '&volume=' + self.props.match.params.volume + '&issue=' + self.props.match.params.issue + '&User= &Subscribed=' + data.subscribed + '&platform=klo&useragent=' + useragent;
                    const script = document.createElement("script");
                    script.src = "/siqpagetag.js";
                    script.async = true;
                    document.body.appendChild(script);
                }

                var msg = {
                    ArticleTitle: window['NTPT_PGEXTRA']
                }
                var Logurl = 'Product/LogData';
                appService.submit(Logurl, msg).then(function (data) {

                });

                ReactGA.initialize(
                    [
                        {
                            trackingId: 'UA-2905701-8',
                            gaOptions: { name: 'tracker1' }
                        },
                        {
                            trackingId: 'UA-72849501-2',
                            gaOptions: { name: 'tracker2' }
                        }
                    ],
                    { alwaysSendToDefaultTracker: false }
                );

                ReactGA.pageview(window.location.pathname, ['tracker1', 'tracker2'], data.title + " - Kluwer Law Online");
                var metas = document.getElementsByTagName('meta');
                for (let i = 0; i < metas.length; i++) {
                    if (metas[i].getAttribute('name') == "robots") {
                        console.log(metas[i]);
                        metas[i].remove();
                    }
                }
            });


    }

    renderAccordian = () => {
        return <div className="row" style={{ display: 'block' }}>
            <div>
            {//this.state.uniqueTitle.map(item => {
                // return (
                    !this.state.isArticleTypeDevided ? 
                this.state.articlesList.map(subitem => {
                    return (
                        <div style={{ width: '100%' }}>
                            {(() => {
                                {
                                    (subitem.articleAbstract != '' && subitem.articleAbstract != null)
                                        ?
                                        Hidebutton = true
                                        :
                                        null
                                }
                                VolumeId = this.state.volid;
                                path = "/journalarticle/" + this.state.journalTitle.replace(/ /g, "+") + "/" + this.state.volumeNo + "." + this.state.issueTextNo + "/" + subitem.docId;
                                {/*path = "/JournalsArticle?prddtlid=" + subitem.id + "&volid=" + VolumeId + "&issid=" + subitem.issueId + "&prdid=" + subitem.productId;*/ }
                                //if (item === subitem.articleType) {
                                const authorNames = subitem.authors != null && subitem.authors != 'undefined' && subitem.authors.map((authoritem, index) => {
                                    return index == 0 ?
                                        <span onClick={() => this.searchAuthorContent(authoritem.firstName + " " + authoritem.surname)}> <span className="HoverUnderline">{this.decodeHtml(authoritem.firstName) + " " + this.decodeHtml(authoritem.surname)}</span>
                                        </span >
                                        :
                                        <span onClick={() => this.searchAuthorContent(authoritem.firstName + " " + authoritem.surname)}>, <span className="HoverUnderline">{this.decodeHtml(authoritem.firstName) + " " + this.decodeHtml(authoritem.surname)}</span>
                                        </span >
                                })
                                return (
                                    <div>

                                        <h4>
                                            <Link to={path} onClick={this.handleSelect} style={{ fontSize: '17px', fontWeight: 'bold' }} dangerouslySetInnerHTML={{ __html: subitem.title }}>
                                            </Link> <span style={{ fontSize: '17px' }}>(p. {subitem.firstPage})</span> {this.state.Subscribed == true ? <img alt="" src={"/../../images/green-tick.svg"} /> : null}
                                        </h4>
                                        <div className="LinkClass">
                                            {
                                                authorNames
                                            }
                                        </div>
                                        {this.state.showAbstractText ?
                                            <div style={{ textAlign: 'justify' }} dangerouslySetInnerHTML={{ __html: subitem.articleAbstract }}>
                                            </div>
                                            :
                                            null
                                        }
                                        <hr className="HrCSS DM" style={{ marginBottom: '15px', marginTop: '15px' }}></hr>
                                    </div>


                                )
                                //}
                            }
                            )()}
                        </div>
                    )

                    //    )

                })

                :

                        this.state.articleType.map((item, index) => {
                    return (
                        <div style={{ width: '100%' }}>
                            <br />
                            <div style={accordion} onClick={this.HandleClick} id={index + "_" + index}>
                                <span style={AccordionTitle}>{item.typeName}</span>
                                    {
                                        true ?
                                        this.state.ShowSublist.indexOf(index + "_" + index) > -1 ?
                                                <i style={{ fontSize: '25px', float: 'right', color: 'lightgrey', marginRight: '5px', zindex: '1', position: 'relative' }}
                                                    className="fa fa-chevron-up"></i>
                                                :
                                                <i style={{ fontSize: '25px', float: 'right', color: 'lightgrey', marginRight: '5px', zindex: '1', position: 'relative' }}
                                                    className="fa fa-chevron-down"></i>
                                            :
                                            null
                                    }

                                </div>
                                <div style={{borderLeft: '1px solid #CCCCCC', borderRight: '1px solid #CCCCCC', borderBottom: '1px solid #CCCCCC' }}>
                                {this.state.ShowSublist.indexOf(index + "_" + index) > -1 ?

                                    item.articles.map((subitem, subIndex) => {
                                        return (
                                            <div style={{ paddingTop: subIndex ==0?'10px':'0px', width: '100%' }}>
                                                {(() => {
                                                    {
                                                        (subitem.articleAbstract != '' && subitem.articleAbstract != null)
                                                            ?
                                                            Hidebutton = true
                                                            :
                                                            null
                                                    }
                                                    VolumeId = this.state.volid;
                                                    path = "/journalarticle/" + this.state.journalTitle.replace(/ /g, "+") + "/" + this.state.volumeNo + "." + this.state.issueTextNo + "/" + subitem.docId;
                                                    {/*path = "/JournalsArticle?prddtlid=" + subitem.id + "&volid=" + VolumeId + "&issid=" + subitem.issueId + "&prdid=" + subitem.productId;*/ }
                                                    //if (item === subitem.articleType) {
                                                    const authorNames = subitem.authors != null && subitem.authors != 'undefined' && subitem.authors.map((authoritem, index) => {
                                                        return index == 0 ?
                                                            <span onClick={() => this.searchAuthorContent(authoritem.firstName + " " + authoritem.surname)}> <span className="HoverUnderline">{this.decodeHtml(authoritem.firstName) + " " + this.decodeHtml(authoritem.surname)}</span>
                                                            </span >
                                                            :
                                                            <span onClick={() => this.searchAuthorContent(authoritem.firstName + " " + authoritem.surname)}>, <span className="HoverUnderline">{this.decodeHtml(authoritem.firstName) + " " + this.decodeHtml(authoritem.surname)}</span>
                                                            </span >
                                                    })
                                                    return (
                                                        <div>

                                                            <h4 style={{marginLeft:'2%'}}>
                                                                <Link to={path} onClick={this.handleSelect} style={{ fontSize: '17px', fontWeight: 'bold' }} dangerouslySetInnerHTML={{ __html: subitem.title }}>
                                                                </Link> <span style={{ fontSize: '17px' }}>(p. {subitem.firstPage})</span> {this.state.Subscribed == true ? <img alt="" src={"/../../images/green-tick.svg"} /> : null}
                                                            </h4>
                                                            <div className="LinkClass" style={{ marginLeft: '2%' }}>
                                                                {
                                                                    authorNames
                                                                }
                                                            </div>
                                                            {this.state.showAbstractText ?
                                                                <div style={{ marginLeft: '2%', marginRight: '2%', textAlign: 'justify' }} dangerouslySetInnerHTML={{ __html: subitem.articleAbstract }}>
                                                                </div>
                                                                :
                                                                null
                                                            }
                                                            <hr className="HrCSS DM" style={{ marginBottom: '15px', marginTop: '15px' }}></hr>
                                                        </div>


                                                    )
                                                    //}
                                                }
                                                )()}
                                            </div>
                                        )

                                        //    )

                                    })

                                        : null}
                                </div>
                    </div>)
                })
            } 
                
            </div>
        </div>
        
    }

    //Start:Pradip Lalvani -New
    handleValidation() {
        var self = this;
        //let fields = self.state.fields;
        //let errors = {};
        let formIsValid = true;

        var emailTo = this.refs["emailTo"].value;
        //var Body = this.refs["Body"].value;
        //var emailTo = this.refs["emailTo"].value;
        //var Body = this.refs["Body"].value;
        var emailName = this.refs["emailName"].value;

        if (emailName == "") {
            formIsValid = false;
            this.setState({
                emailName: "* Required field"
            });
            //this.state.emailName = "* Required field";
        }
        else {
            this.state.emailName = "";
        }
        if (emailTo == "") {
            formIsValid = false;
            this.setState({
                emailReciepient: "* Required field"
            });
            //this.state.emailReciepient = "* Required field";
        }

        if (emailTo != "") {
            let lastAtPos = emailTo.lastIndexOf('@');
            let lastDotPos = emailTo.lastIndexOf('.');

            if (!(lastAtPos < lastDotPos && lastAtPos > 0 && emailTo.indexOf('@@') == -1 && lastDotPos > 2 && (emailTo.length - lastDotPos) > 2)) {
                formIsValid = false;
                this.setState({
                    emailReciepient: "* Please enter a valid email address"
                });
                //this.state.emailReciepient = "* Please enter a valid email address";
            }
        }

        //self.setState({ errors: errors });
        if (!formIsValid) {
            window.scrollTo({
                top: 200,
                behavior: 'smooth',
            });
            return false;
        }

        return true;
    }
    downloadPDF(url, issueId) {
        //creating an invisible element 
        //var element = document.createElement('a');
        //element.setAttribute('href', url);
        //element.setAttribute('download', "Journal Article Issue_"+ issueId + ".pdf");
        //element.setAttribute('target', '_blank');
        //document.body.appendChild(element);
        //element.click();
        //document.body.removeChild(element);

        //this.state.articlesList.map(articleitem => {
        //    //for author name 
        //    var articleAuthors = "";
        //    if (articleitem.authors != null && articleitem.authors != 'undefined') {
        //        Object.entries(articleitem.authors).map((authoritem, index) => {
        //            authorFullName = "";
        //            authorFullName = this.decodeHtml(authoritem[1].firstName) + " " + this.decodeHtml(authoritem[1].surname);
        //            articleAuthors += index == 0 ? authorFullName : ", " + authorFullName;
        //        })
        //    }

        //    window['NTPT_PGEXTRA'] = 'event_type=full-text pdf&ProductId=' + this.state.journalIssues.id + ' &ProductTitle=' + this.state.journalTitle + ' &volume=' + this.state.volumeNo + ' &issue=' + this.state.issueText + ' &article_id=' + articleitem.docId + ' &article_title= ' + articleitem.title + '&authors=' + articleAuthors + '&user_id=' + localStorage.getItem('salesForceID') + '&user=' + localStorage.getItem('user') + ' &Subscribed=' + this.state.Subscribed + '&platform=klo &useragent=' + useragent;
        //    const script = document.createElement("script");
        //    script.src = "/siqpagetag.js";
        //    script.async = false;
        //    document.body.appendChild(script);
        //});
        window.open(url);
    }

    handleSubmit(event) {
        //event.preventDefault();
        if (this.handleValidation()) {
            this.state.emailName = '';
            this.state.emailReciepient = '';
            var emailTo = this.refs["emailTo"].value;
            var Body = 'Dear ' + this.refs["emailName"].value + ",";
            var Subject = this.state.Subject;
            var isNotForLink = true;

            parameters = { To: emailTo, Body: Body, Subject: Subject, isNotForLink: isNotForLink, FileName: fileName };

            appService.getByIssueId('/Email/SendEmail', parameters)
                .then(function (data) {

                    if (data == "Success") {
                        window.location = "/ThankyouSubscription";
                    }
                });
        }
        else {
            return false;
        }
    }
    //End:Pradip Lalvani -New

    render() {
        if (this.state.redirectToLogin) {
            this.setState({ redirectToLogin: false });
            return <Redirect to={"/Login"} />
        }
        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
            "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
        ];


        if (this.state.redirectToSearch) {
            this.setState({ redirectToSearch: false });
            return <Redirect to={"/SearchContent/query=?authorString=" + this.state.searchAuthor} />;
        }

        {
            this.state.showAbstractText ?
                AbstractTitle = "Hide abstracts"
                :
                AbstractTitle = "Show abstracts"
        }

        const renderSamplePDF = this.state.samplePDF !== undefined && Object.entries(this.state.samplePDF).map((item, index) => {

            return <div className="TopicBorder" id="Samplearticle">
                <br></br>
                <p className="paddingL" style={{ margin: '0' }}>
                    <a className="LinkClass margintop HoverUnderline" style={{ cursor: 'pointer' }} onClick={(e) => this.handleShow(item[1].fileName)} dangerouslySetInnerHTML={{ __html: item[1].articleTitle }}></a> (PDF)
                        </p><br></br>
            </div>

        })

        this.state.articlesList.map(articleitem => {
            if (this.state.uniqueTitle.indexOf(articleitem.articleType) === -1) {
                options = this.state.uniqueTitle;
                options.push(articleitem.articleType);
                this.setState({
                    uniqueTitle: options
                })

            }

            //  AbstractArticle = articleitem.articleAbstract

        })
        var journalTitlePlus = typeof this.state.journalTitle == 'undefined' ? "" : this.state.journalTitle.replace(/ /g, "+");
        const meta = {
            title: this.state.journalTitle + " - Kluwer Law Online",
            // description: "View issue " + this.props.match.params.issue + ", volume " + this.props.match.params.volume + " of " + this.props.match.params.title + "",
            canonical: window.location.href,
            //meta: {
            //    charset: "utf-8",
            //    name: {
            //        citation_journaltitle: this.props.match.params.title,
            //        citation_number: this.state.journalIssues.id,
            //        citation_volume: this.props.match.params.volume,
            //        citation_issue: this.props.match.params.issue,
            //       // citation_publicationdate: monthNames[this.state.PublicationMon - 1] + ' ' + this.state.Publishedyear,
            //        citation_main_editors: this.state.mainEditors,
            //        title: this.props.match.params.title + " | Vol." + this.props.match.params.volume + ", no. " + this.props.match.params.issue + " | Kluwer Law Online",
            //        description: "View issue " + this.props.match.params.issue + ", volume " + this.props.match.params.volume + " of " + this.props.match.params.title + ""
            //    }
            //}
        }

        return (
            <DocumentMeta {...meta}>
                <div>
                    <div className="col-12">
                        <div className="row">
                            <div className="col-sm-9">
                                <p className="TitlePadding SetPaddingforP">
                                    <Link to="/" className="LinkClass">Home</Link> > <Link to="/AllJournals" className="LinkClass" > All journals</Link> > <Link className="LinkClass" to={"/Journals/" + journalTitlePlus + "/" + this.state.journalIssues.id} >
                                        <div style={{ display: 'inline-block' }} dangerouslySetInnerHTML={{ __html: this.state.journalTitle }} className="HoverUnderline"></div>
                                    </Link> > <div style={{ display: 'inline-block' }} dangerouslySetInnerHTML={{ __html: this.state.volumeNo + "(" + this.state.issueText != null ? this.state.issueText : "Issue " + this.state.issueNo + ")" }} ></div>
                                </p>
                            </div>

                        </div>

                        <div className="row AllColPadding margintop">

                            <div className="col-lg-8" style={{ minWidth: '73%' }}>

                                <div className="row">
                                    <div className="JournalFlex">
                                        <img alt={"Cover Image for " + this.state.journalTitle} src={"/../../images/books/" + this.state.journalImage} className="TitleImg" />
                                        <h1 className="paddingL PublicationTitle VolumeDetails">
                                            <span style={{ lineHeight: '25px' }}> Volume {this.state.volumeNo}, <span style={{ fontWeight: 'bold' }}> {this.state.issueText != null ? this.state.issueText : "Issue " + this.state.issueNo}</span></span> <span style={{ fontSize: '15px' }}>(p. {this.state.FirstRange}-{this.state.LastRange})</span>
                                            <br></br>
                                            <Link style={{ fontStyle: 'italic' }} to={"/Journals/" + journalTitlePlus + "/" + this.state.journalIssues.id} className="ArticleChapter" dangerouslySetInnerHTML={{ __html: this.state.journalTitle }}></Link>
                                            <p>
                                                {monthNames[this.state.PublicationMon - 1] + ' ' + this.state.Publishedyear}
                                            </p>
                                        </h1>
                                    </div>
                                </div>
                                {this.state.login && this.state.Subscribed ?
                                    <div style={{ float: 'right' }}>
                                        <Link to="#" onClick={() => this.downloadPDF('api/Product/GetFileName?issueId=' + issueId, issueId)} style={{ fontStyle: 'normal' }} className="ArticleChapter">Open complete issue in one PDF</Link>
                                    </div> : null
                                }
                                <br></br>
                                <br></br>
                                <div className="row">
                                    <div className="col-lg-9"></div>
                                    {Hidebutton == true ?
                                        <div className="col-lg-3" style={{ paddingLeft: '6%' }}>
                                            <div className="dropdown">
                                                <button className="dropbtn issueDrpdown" onClick={() => this.setState({ showAbstractText: !this.state.showAbstractText })}>
                                                    <strong className="Fleft issueDrpdownContent">
                                                        {AbstractTitle}</strong>
                                                    {this.state.showAbstractText ?
                                                        <FaChevronUp style={{ float: 'right', fontSize: '20px', color: 'lightgrey', marginTop: '3%' }} />

                                                        :
                                                        <FaChevronDown style={{ float: 'right', fontSize: '20px', color: 'lightgrey', marginTop: '2%' }} />
                                                    }
                                                </button>
                                            </div>
                                        </div>
                                        :
                                        null
                                    }
                                </div>

                                <div className="row">
                                    <div className="col-lg-12" style={{ paddingLeft: '0px' }}>
                                        <hr className="HrCSS" style={{ width: '101.3%' }}></hr>
                                    </div>
                                </div>
                                {this.renderAccordian()}
                                <br></br>
                                <div className="row" style={{ float: 'right' }}>

                                    {(() => {
                                        //console.log(this.state.PrevIssueNo)
                                        //var journalTitlePlus = this.state.journalTitle.replace(/ /g, "+");
                                        if (this.state.PrevIssueNo === undefined && this.state.NextIssueNo !== undefined) {
                                            return (
                                                <div className="pagination Fright">
                                                    <Link to={"/journalIssue/" + journalTitlePlus + "/" + this.state.volumeNo + "." + this.state.NextIssueTextNo + "/" + this.state.NextIssueId} className="paginationpadding">{this.state.NextIssueText != null ? this.state.NextIssueText : "Issue " + this.state.NextIssueNo}</Link>
                                                    <Link to={"/journalIssue/" + journalTitlePlus + "/" + this.state.volumeNo + "." + this.state.NextIssueTextNo + "/" + this.state.NextIssueId}><i className="fa fa-angle-right"><span class="sr-only sr-only-focusable">Arrow button used to open the Next Issue</span></i></Link>

                                                    {/* <a href={"/JournalIssue?Issueid=" + this.state.NextIssueId + "&Volumeid=" + params.Volumeid + "&Productid=" + params.Productid} className="paginationpadding">Issue {this.state.NextIssueNo}</a>
                                                    <a href={"/JournalIssue?Issueid=" + this.state.NextIssueId + "&Volumeid=" + params.Volumeid + "&Productid=" + params.Productid}><i className="fa fa-angle-right"></i></a> */}
                                                </div>
                                            )
                                        }
                                        else
                                            if (this.state.PrevIssueNo !== undefined && this.state.NextIssueNo === undefined) {
                                                return (
                                                    <div className="pagination Fright">
                                                        <Link to={"/journalIssue/" + journalTitlePlus + "/" + this.state.volumeNo + "." + this.state.PrevIssueTextNo + "/" + this.state.PrevIssueId} ><i className="fa fa-angle-left"><span class="sr-only sr-only-focusable">Arrow button used to open the Previous Issue</span></i></Link>
                                                        <Link to={"/journalIssue/" + journalTitlePlus + "/" + this.state.volumeNo + "." + this.state.PrevIssueTextNo + "/" + this.state.PrevIssueId} className="paginationpadding">{this.state.PrevIssueText != null ? this.state.PrevIssueText : "Issue " + this.state.PrevIssueNo}</Link>
                                                        {/* <a href={"/JournalIssue?Issueid=" + this.state.PrevIssueId + "&Volumeid=" + params.Volumeid + "&Productid=" + params.Productid} ><i className="fa fa-angle-left"></i></a>
                                                        <a href={"/JournalIssue?Issueid=" + this.state.PrevIssueId + "&Volumeid=" + params.Volumeid + "&Productid=" + params.Productid} className="paginationpadding">Issue {this.state.PrevIssueNo}</a> */}
                                                    </div>
                                                )
                                            }

                                            else {
                                                if (this.state.PrevIssueNo !== undefined && this.state.NextIssueNo !== undefined) {
                                                    return (
                                                        <div className="pagination Fright">
                                                            <Link to={"/journalIssue/" + journalTitlePlus + "/" + this.state.volumeNo + "." + this.state.PrevIssueTextNo + "/" + this.state.PrevIssueId} ><i className="fa fa-angle-left"><span class="sr-only sr-only-focusable">Arrow button used to open the Previous Issue</span></i></Link>
                                                            <Link to={"/journalIssue/" + journalTitlePlus + "/" + this.state.volumeNo + "." + this.state.PrevIssueTextNo + "/" + this.state.PrevIssueId} className="paginationpadding paginationBorder">{this.state.PrevIssueText != null ? this.state.PrevIssueText : "Issue " + this.state.PrevIssueNo}</Link>
                                                            <Link to={"/journalIssue/" + journalTitlePlus + "/" + this.state.volumeNo + "." + this.state.NextIssueTextNo + "/" + this.state.NextIssueId} className="paginationpadding">{this.state.NextIssueText != null ? this.state.NextIssueText : "Issue " + this.state.NextIssueNo}</Link>
                                                            <Link to={"/journalIssue/" + journalTitlePlus + "/" + this.state.volumeNo + "." + this.state.NextIssueTextNo + "/" + this.state.NextIssueId}><i className="fa fa-angle-right"><span class="sr-only sr-only-focusable">Arrow button used to open the Next Issue</span></i></Link>
                                                            {/* <a href={"/JournalIssue?Issueid=" + this.state.PrevIssueId + "&Volumeid=" + params.Volumeid + "&Productid=" + params.Productid} ><i className="fa fa-angle-left"></i></a>
                                                            <a href={"/JournalIssue?Issueid=" + this.state.PrevIssueId + "&Volumeid=" + params.Volumeid + "&Productid=" + params.Productid} className="paginationpadding paginationBorder">Issue {this.state.PrevIssueNo}</a>
                                                            <a href={"/JournalIssue?Issueid=" + this.state.NextIssueId + "&Volumeid=" + params.Volumeid + "&Productid=" + params.Productid} className="paginationpadding">Issue {this.state.NextIssueNo}</a>
                                                            <a href={"/JournalIssue?Issueid=" + this.state.NextIssueId + "&Volumeid=" + params.Volumeid + "&Productid=" + params.Productid}><i className="fa fa-angle-right"></i></a> */}
                                                        </div>
                                                    )
                                                }
                                            }
                                    }
                                    )()}


                                </div>
                            </div>


                            <div className="col-lg-3">
                                {(!this.state.login && !this.state.Subscribed) || (this.state.login && !this.state.Subscribed) ?
                                    <div>
                                        <div className="TopicBorder BGGrey" id="Subcribeto" style={{ borderTop: '2px solid #CCCCCC', paddingBottom: '3%', paddingTop: '3%', fontSize: '18px' }}>
                                            <span className="paddingL fontbold margintop SetPaddingforP"> Subscribe to this journal </span>
                                        </div>
                                        <div className="TopicBorder" id="Pricemenu">
                                            <p className="paddingL fontbold" style={{ lineHeight: '3', marginBottom: '3%' }}>Interested in a subscription?
                                                    <Link to="/ContactSales" variant="secondary" style={{ marginTop: '3%', textAlign: 'center' }} className="Modalbutton Setwdth HoverUnderline">  <strong> Contact our sales team</strong> </Link>
                                            </p>
                                        </div>
                                        
                                        {
                                            this.state.samplePDF !== undefined && this.state.samplePDF.length > 0 ?
                                                < div >
                                                    <div className="TopicBorder BGGrey" id="Takealook" style={{ paddingBottom: '2%', paddingTop: '2%', fontSize: '18px' }}>
                                                        <span className="paddingL fontbold margintop SetPaddingforP"> Sample content </span>
                                                    </div>
                                                    {renderSamplePDF}
                                                </div>
                                                :
                                                null}
                                    </div>
                                    : null}
                                <Modal show={this.state.show} onHide={this.handleClose}  {...this.props}
                                    size="md"
                                    aria-labelledby="contained-modal-title-vcenter"
                                    centered>
                                    <Modal.Header closeButton className="Popupcolor">
                                        <Modal.Title>Sample content</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        <div className="col-8">
                                            <label htmlFor="Name">Name</label>
                                            <input type="text" className="form-control form-control-sm rounded-0" ref="emailName" placeholder="Enter your name" id="Name" />
                                            <span className="errorMsg">{this.state.emailName}</span>
                                        </div>
                                        <br></br>
                                        <div className="col-8">
                                            <label htmlFor="Email">Email</label>
                                            <input type="text" className="form-control form-control-sm rounded-0" ref="emailTo" placeholder="Enter your email" id="Email" />
                                            <span className="errorMsg">{this.state.emailReciepient}</span>
                                        </div>
                                        <br></br>
                                        <div className="col-8">
                                            <a href="http://www.kluwerlaw.com/terms-and-conditions/" target="_blank">Terms and Conditions</a>
                                        </div>
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <div className="row">
                                            <div className="col" style={{ paddingLeft: '6%' }}>
                                                <span variant="secondary" className="Modalbutton HoverUnderline" onClick={this.handleClose}>  Return to site </span>
                                            </div>
                                            <div className="col TopicPadding">

                                                <button type="button" className="btn btn-info next rounded-0" onClick={this.handleSubmit}>Submit</button>

                                            </div>
                                        </div>
                                    </Modal.Footer>
                                </Modal>
                                <div className="TopicBorder BGGrey" style={{ paddingBottom: '3%', paddingTop: '3%', fontSize: '18px' }}>
                                    <span className="paddingL fontbold margintop SetPaddingforP"> Browse by practice area </span>
                                </div>
                                <div className="TopicBorder">
                                    <br></br>
                                    {this.state.TopicName !== undefined ?
                                        <Link to={"/PracticeArea?Id=" + this.state.TopicId + "&name=" + this.state.TopicName.replace(/ /g, "+")} onClick={this.handleSelect} className="paddingL LinkClass margintop" style={this.state.TopicName.length > 33 ? Displaystyle : null}>{this.state.TopicName} </Link>
                                        :
                                        null
                                    }

                                    <br></br> <br></br>
                                </div>
                                <div className="TopicBorder BGGrey" style={{ paddingBottom: '3%', paddingTop: '3%', fontSize: '18px' }}>
                                    <span className="paddingL fontbold margintop SetPaddingforP"> Share </span>
                                </div>
                                <div className="TopicBorder">
                                    <br></br>
                                    <CopyToClipboard text={document.location.href}>
                                        <span data-tooltip="Share on Linkedin" className="RSSCard Shareicon-margin" >
                                            <a href={"https://www.linkedin.com/shareArticle?mini=true&url=" + window.location.href + "&title=&summary=&source="}
                                                target="_blank" title="Share on Linkedin">
                                                <i class="fa fa-linkedin shareicons colPadding btn-fa" aria-hidden="true"></i></a>
                                        </span>
                                    </CopyToClipboard>
                                    <CopyToClipboard text={document.location.href}>
                                        <span data-tooltip="Share on Facebook" className="RSSCard Shareicon-margin" >
                                            <a href={"https://www.facebook.com/sharer/sharer.php?u=" + window.location.href}
                                                target="_blank" title="Share on Facebook">
                                                <i class="fa fa-facebook shareicon-facebook colPadding btn-fa" aria-hidden="true"></i></a>
                                        </span>
                                    </CopyToClipboard>
                                    {/* <span onClick={this.handleEmailModalShow} className="RSSCard Shareicon-margin" data-tooltip="Share by Email">
                                        <i class="fa fa-envelope shareicons colPadding btn-fa" aria-hidden="true"></i>
                                    </span> */}
                                    <br></br>
                                    <br></br>
                                </div>
                                <EmailModal show={this.state.handleEmailModalShow} onHide={this.handleEmailModalClose}  {...this.props}
                                    size="lg"
                                    aria-labelledby="contained-modal-title-vcenter"
                                    centered>
                                    <EmailModal.Header closeButton className="Popupcolor">
                                        <Modal.Title>
                                            Share by email
                                            </Modal.Title>
                                    </EmailModal.Header>
                                    <EmailModal.Body>
                                        <div>
                                            <div className="row mt-3 AllColPadding">
                                                <div className="col-lg-6 TopicPadding">
                                                    <label for="To">To</label>
                                                    <input type='email' id="email" name="email" ref="email" className="form-control form-control-sm rounded-0"
                                                        placeholder="Enter your email address(es); separated by semi-colon" />
                                                    <span className="error">{this.state.emailRec}</span>
                                                </div>
                                            </div>
                                            <div className="row mt-3 AllColPadding">
                                                <div className="col-lg-6 TopicPadding">
                                                    <label for="SubjectTitle">Subject</label>
                                                    <input type="text" ref="SubjectTitle" className="form-control form-control-sm rounded-0" placeholder={this.state.journalTitle} id="SubjectTitle" name="SubjectTitle" />
                                                </div>
                                            </div>
                                            <div className="row mt-3 AllColPadding">
                                                <div className="col-lg-6 TopicPadding">
                                                    <label for="URL" style={{ fontSize: '12px' }}>{window.location.href}</label>
                                                    <textarea
                                                        className="form-control"
                                                        id="addInfo"
                                                        name="addInfo"
                                                        rows="3" placeholder="Enter message" ref="AddInfo"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </EmailModal.Body>
                                    <EmailModal.Footer>
                                        <div className="row AllColPadding">
                                            <div className="col-sm-8 TopicPadding ">
                                                <span variant="secondary" className="Modalbutton HoverUnderline" onClick={this.handleEmailModalClose}>  Return to site </span>
                                            </div>
                                            <div className="col-sm-4 TopicPadding">
                                                <button variant="primary" className="btn btn-info next FloatSet" onClick={this.sendShareByEmail}>
                                                    Submit
                                    </button></div>
                                        </div>
                                    </EmailModal.Footer>
                                </EmailModal>
                                <div className="TopicBorder BGGrey" style={{ paddingBottom: '3%', paddingTop: '3%', fontSize: '18px' }}>
                                    <span className="paddingL fontbold margintop SetPaddingforP"> Stay up to date </span>
                                </div>
                                <div className="TopicBorder" style={{ paddingBottom: '3%' }}>
                                    <br></br>
                                    <a className="LinkClass RSSCard" style={{ cursor: 'pointer', display: 'none' }} href={'api/Product/RenderXML?file=' + "AllJournal.xml"} target="_blank" title="Open RSS feed" data-tooltip="RSS feed for this title">
                                        <img className="colPadding btn-fa" alt="" src="/../../images/rss.png" />
                                        <img alt="" src="/../../images/rss-mouseover.png" class="img-Email colPadding btn-fa" />
                                    </a>
                                    <Link to="/Etoc" onClick={this.handleSelect} className="RSSCard Shareicon-margin" data-tooltip="Table of contents alert for this title" title="Table of contents alert for this title">
                                        <i class="fa fa-clock-o shareicon-ETOC colPadding btn-fa" aria-hidden="true"></i>
                                    </Link>
                                    <br></br>
                                    <span style={{ fontSize: '11px', color: '#757575', marginLeft: '7%' }}>ETOC</span>
                                    <br></br>
                                </div>
                                <EmailModal show={this.state.handleEtocModalShow} onHide={this.handleEtocModalClose}  {...this.props}
                                    size="lg"
                                    aria-labelledby="contained-modal-title-vcenter"
                                    centered>
                                    <EmailModal.Header closeButton className="Popupcolor">
                                        <Modal.Title>
                                            Table of Contents alert (ETOC)
                                            </Modal.Title>
                                    </EmailModal.Header>
                                    <EmailModal.Body>
                                        <div>
                                            <div className="row mt-6 AllColPadding">
                                                <div className="col-lg-6 TopicPadding">
                                                    <label>Sign up for ETOC alerts to receive an e-mail informing you when new content for Kluwer Law Online prodcuts is available online. Login or create an account and select the title(s) you wish to subscribe to.</label>

                                                </div>
                                            </div>

                                        </div>
                                    </EmailModal.Body>
                                    <EmailModal.Footer>
                                        <div className="row AllColPadding">

                                            <div className="col-sm-4 TopicPadding">

                                                <span variant="secondary" className="Modalbutton HoverUnderline" onClick={this.logoutsession}>  Login/Create Account </span>
                                            </div>
                                            <div className="col-sm-8 TopicPadding ">
                                                <span variant="secondary" className="Modalbutton HoverUnderline" onClick={this.handleEtocModalClose}>  Return to site </span>
                                            </div>
                                        </div>
                                    </EmailModal.Footer>
                                </EmailModal>
                            </div>
                        </div>
                        <div className="White">
                        </div>
                    </div>
                </div>
            </DocumentMeta>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Journals/JournalIssue.jsx